import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './RothConversionWhatsNext.scss';

import config from '../../../../config/config';
import ConfirmationExitBox from '../../ConfirmationExitBox';
import {
  getAcceptedRI2020WithholdingDisclosure,
  getExchangeToContainsNewFund,
} from '../../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { getEligibleBanks } from '../../../../redux/modules/existingBanks/existingBanks.selectors';
import Button from '../../../Shared/Button/Button';
import stampDocument from '../../../../assets/images/stamp-document.svg';
import dollarSignMonitor from '../../../../assets/images/dollar-sign-monitor.svg';
import bankSellConfirm from '../../../../assets/images/bank-sell-confirm.svg';
import recurringCalendar from '../../../../assets/images/recurring-calendar.svg';
import sellDashboard from '../../../../assets/images/sell-dashboard.svg';
import { appendBasePath } from '../../../../utils/nav.utils';
import onTrack from '../../../../assets/images/on-track.png';

const RothConversionWhatsNext = ({
  acceptedRI2020WithholdingDisclosure,
  eligibleBanks,
  exchangeToContainsNewFund,
}) => (
  <div className="container exchange-whats-next-mobile-buttons-container">
    <div className="exchange-whats-next-mobile-buttons">
      <a
        href={
          exchangeToContainsNewFund
            ? `${config.url}/usis/my-accounts/profile/trusted-contacts`
            : `${config.url}${appendBasePath('/landing')}`
        }
      >
        <Button buttonType="secondary-ghost">Submit Another Transaction</Button>
      </a>
      <a href={`${config.url}/usis/my-accounts/dashboard`}>
        <Button buttonType="secondary-ghost">Go to Dashboard</Button>
      </a>
    </div>
    <div className="exchange-whats-next-desktop-container">
      <div className="exchange-whats-next-exit-heading">What&apos;s next?</div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          {exchangeToContainsNewFund ? (
            <ConfirmationExitBox
              id={'confirm-trusted-contact'}
              className={'e2e-confirm-trusted-contact'}
              heading={'Add a Trusted Contact'}
              subHeading={`Help us protect your accounts from financial exploitation`}
              image={stampDocument}
              exitLocation={`${config.url}/usis/my-accounts/profile/trusted-contacts`}
            />
          ) : (
            <ConfirmationExitBox
              id="confirm-are-you-on-track"
              className="e2e-confirm-submit-another-trade"
              heading="Are you on track"
              subHeading={
                <span>
                  Get started with our retirement income calculator to receive
                  an estimate of where you stand for retirement.
                </span>
              }
              image={onTrack}
              exitLocation={`${config.url}/usis/advice/tools/retirement-income-calculator`}
            />
          )}
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          {acceptedRI2020WithholdingDisclosure ? (
            <ConfirmationExitBox
              id="confirm-add-bank"
              className="e2e-confirm-dividend-distributions"
              heading="Cash Dividend Distributions"
              subHeading="For additional information, or to request an alternate withholding rate, please visit our Dividend and Capital Gains page on the following business day."
              image={bankSellConfirm}
              exitLocation={`${config.url}/usis/my-accounts/profile/dividends-and-capital-gains`}
            />
          ) : isEmpty(eligibleBanks) ? (
            <ConfirmationExitBox
              id="confirm-make-one-time-trade"
              className="e2e-confirm-add-bank"
              heading="Make A One-Time Trade"
              subHeading="Buy, sell, or exchange using your T. Rowe Price accounts."
              image={dollarSignMonitor}
              exitLocation={`${config.url}${appendBasePath('/landing')}`}
            />
          ) : (
            <ConfirmationExitBox
              id="confirm-setup-recurring"
              className="e2e-confirm-setup-recurring"
              heading="Set Up Recurring Investments"
              subHeading="Scheduling automatic deposits makes adding to your portfolio simple"
              image={recurringCalendar}
              exitLocation={`${config.url}${appendBasePath('/automatic')}`}
            />
          )}
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id="confirm-view-dashboard"
            className="e2e-confirm-view-dashboard"
            heading="View Dashboard"
            subHeading="Review your portfolio and track how your investments are performing."
            image={sellDashboard}
            exitLocation={`${config.url}/usis/my-accounts/dashboard`}
          />
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = (state) => {
  return {
    acceptedRI2020WithholdingDisclosure:
      getAcceptedRI2020WithholdingDisclosure(state),
    eligibleBanks: getEligibleBanks(state),
    exchangeToContainsNewFund: getExchangeToContainsNewFund(state),
  };
};

export default compose(connect(mapStateToProps))(RothConversionWhatsNext);
